function t(n) {
  return n !== null;
}
function i(n) {
  return n !== void 0;
}
function r(n) {
  return t(n) && i(n);
}
function e(n) {
  return r(n);
}
function u(n) {
  return r(n) && n.length > 0;
}
const s = n => n == null || n == null ? !1 : n.trim() != "";
export { u as a, e as i, s };